import { Component, ViewEncapsulation } from '@angular/core';

import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';

@Component({
  selector: 'email-recruitee-logo',
  styleUrls: ['./email-recruitee-logo.component.less'],
  template: `
    <img
      class="logo"
      [src]="'assets/logo-recruitee-by-tellent.png'"
      [width]="144"
      [height]="44"
      alt="Recruitee"
    />
  `,
  imports: [EmailImageAssetDirective],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class EmailRecruiteeLogoComponent {}
